export default __webpack_public_path__ + "static/reddit-logo-d38d4c42b27099771c06aa16b0c5eeff.svg";